import { render, staticRenderFns } from "./PaymentLoading.vue?vue&type=template&id=21d4efda&scoped=true&"
import script from "./PaymentLoading.vue?vue&type=script&lang=js&"
export * from "./PaymentLoading.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLoading.vue?vue&type=style&index=0&id=21d4efda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d4efda",
  null
  
)

export default component.exports